import { render } from "./LegoCheckbox.vue?vue&type=template&id=678fddd2&scoped=true"
import script from "./LegoCheckbox.vue?vue&type=script&lang=js"
export * from "./LegoCheckbox.vue?vue&type=script&lang=js"

import "./LegoCheckbox.vue?vue&type=style&index=0&id=678fddd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-678fddd2"

export default script